require('bootstrap');

import Vue from 'vue/dist/vue';
window.Vue = Vue;

window.toastr = require('toastr');

Vue.use(require('vue-resource'));

import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDDUQqm--rRc_1Os5wDmtyiAxGmu1HH6EU',
        libraries: 'places',
    },
    installComponents: true,
});

import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);

import Qrcode from 'v-qrcode';
Vue.component('Qrcode', Qrcode);

import VueToggles from 'vue-toggles';
Vue.component('VueToggles', VueToggles);

import Swal from 'sweetalert2';
window.Swal = require('sweetalert2');

window.csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
//Vue.http.headers.common['X-CSRF-TOKEN'] = csrfToken;

Vue.http.interceptors.push((request, next) => {
    request.url.includes(app.domain) ? request.headers.set('X-CSRF-TOKEN', csrfToken) : request.headers.delete('X-CSRF-TOKEN');
    next();
});

import * as helpers from './helpers';
import {formatNumber, formatPrice} from "./helpers";
for (let funcName in helpers) {
    window[funcName] = helpers[funcName];
}

window.RealEstate = require('./models/RealEstate').RealEstate;

Vue.component('ReferenceRealEstatesChart', require('./components/ReferenceRealEstatesChart').default);
Vue.component('RealEstateCard', require('./components/RealEstateCard').default);

Vue.prototype.formatPrice = formatPrice;
Vue.prototype.formatNumber = formatNumber;
Vue.prototype.generateRange = generateRange;
Vue.prototype.avg = avg;
